import { projectFestivalSlice } from '../project-festival.slice';

export const clearCurrentProjectFestival =
  projectFestivalSlice.actions.clearCurrent;
